import React from 'react';

import PharmaDomains from './PharmaDomains/PharmaDomains';
import PharmuniAI from './PharmuniAI/PharmuniAI';
import Certificate from './Certificate/Certificate';

const CorePharmaTopics = () => {
    return (
        <>
            <PharmaDomains />
            <PharmuniAI />
            <Certificate />
        </>
    );
};

export default CorePharmaTopics;
